import BaseStudentModel from "~/models/eschoolplus/registration/Student";

export default class Student extends BaseStudentModel {
  // Define a base url for a REST API
  baseURL() {
    return useRuntimeConfig().public.apiBase + "/api/v2/courserecommendations";
  }

  // Set the resource route of the model
  resource() {
    return "students";
  }
  /*
  relations() {
    return {
    };
  }
*/

  // Computed Attributes

  /**
   *  Handle Changes to Related Data
   **/
  updateRelatedData(model, myKey, matchFn) {
    //console.log("updateRelatedData", model, myKey, matchFn);
    if (typeof this[myKey] != "object" || !Array.isArray(this[myKey])) {
      // Don't care about save.
      return;
    }

    const dataIndex = this[myKey].findIndex(matchFn);
    if (dataIndex == -1) {
      this[myKey].push(model);
    } else {
      this[myKey].splice(dataIndex, 1, model);
    }
  }

  removeRelatedData(model, myKey, matchFn) {
    //console.log("removeRelatedData", model, myKey, matchFn);
    if (typeof this[myKey] != "object" || !Array.isArray(this[myKey])) {
      // Don't care about save.
      return;
    }

    const dataIndex = this[myKey].findIndex(matchFn);
    if (dataIndex != -1) {
      this[myKey].splice(dataIndex, 1);
    }
  }

  // Updated Data
}
